import { connect } from 'react-redux';
import DeskBookingView from '../components/views/DeskBooking';
import type { State } from '../types';

const mapStateToProps = (state: State) => ({
  currentUser: state.currentUser,
  users: state.users,
});

export default connect(mapStateToProps)(DeskBookingView as any);
